import styled from 'styled-components';

export const StyledExpiryCVVWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const StyledExpiryWrapper = styled.div`
  flex-basis: 40%;
  margin-right: 2.5%;
  flex-grow: 1;

  ${Styles.desktop`
    flex-basis: 20%;
  `}
`;

export const StyledCvvWrapper = styled.div`
  flex-basis: 40%;
  margin-left: 2.5%;
  flex-grow: 1;

  ${Styles.desktop`
    flex-basis: 20%;
  `}
`;

export const CardNumberWrapper = styled.div`
  flex-basis: 100%;
  flex-grow: 1;
  position: relative;
  ${Styles.desktop`
    flex-basis: 50%;
  `}
`;
